import { useTranslation } from "react-i18next";
import '../assets/scss/components/skip-activation.scss';

function SkipActivation({ initialValue = false, onChange }) {
  const { t } = useTranslation();
  return (
    <div className="mb-3 skip-activation">
      <input
        type="checkbox"
        checked={initialValue}
        onChange={onChange}
        className="form-check-input"
        id="skip_activation_fee"
      />
      <label className="mb-0" htmlFor="skip_activation_fee">
        {t("Skip Activation Fee")}
      </label>
    </div>
  );
}

export default SkipActivation;
